import type {Country} from '../generated/enums.ts';

export type CountryInfo = {
    country: string;
    nameNl: string;
    code: string;
    iso: Country;
};

export const DEFAULT_COUNTRY_ISO: Country = "NL";

export const COUNTRIES: CountryInfo[] = [
    {"country": "Afghanistan", "nameNl": "Afghanistan", "code": "93", "iso": "AF"},
    {"country": "Åland Islands", "nameNl": "Åland", "code": "358", "iso": "AX"},
    {"country": "Albania", "nameNl": "Albanië", "code": "355", "iso": "AL"},
    {"country": "Algeria", "nameNl": "Algerije", "code": "213", "iso": "DZ"},
    {"country": "American Samoa", "nameNl": "Amerikaans-Samoa", "code": "1-684", "iso": "AS"},
    {"country": "Andorra", "nameNl": "Andorra", "code": "376", "iso": "AD"},
    {"country": "Angola", "nameNl": "Angola", "code": "244", "iso": "AO"},
    {"country": "Anguilla", "nameNl": "Anguilla", "code": "1-264", "iso": "AI"},
    {"country": "Antarctica", "nameNl": "Antarctica", "code": "672", "iso": "AQ"},
    {"country": "Antigua and Barbuda", "nameNl": "Antigua en Barbuda", "code": "1-268", "iso": "AG"},
    {"country": "Argentina", "nameNl": "Argentinië", "code": "54", "iso": "AR"},
    {"country": "Armenia", "nameNl": "Armenië", "code": "374", "iso": "AM"},
    {"country": "Aruba", "nameNl": "Aruba", "code": "297", "iso": "AW"},
    {"country": "Australia", "nameNl": "Australië", "code": "61", "iso": "AU"},
    {"country": "Austria", "nameNl": "Oostenrijk", "code": "43", "iso": "AT"},
    {"country": "Azerbaijan", "nameNl": "Azerbeidzjan", "code": "994", "iso": "AZ"},
    {"country": "Bahamas", "nameNl": "Bahama’s", "code": "1-242", "iso": "BS"},
    {"country": "Bahrain", "nameNl": "Bahrein", "code": "973", "iso": "BH"},
    {"country": "Bangladesh", "nameNl": "Bangladesh", "code": "880", "iso": "BD"},
    {"country": "Barbados", "nameNl": "Barbados", "code": "1-246", "iso": "BB"},
    {"country": "Belarus", "nameNl": "Belarus", "code": "375", "iso": "BY"},
    {"country": "Belgium", "nameNl": "België", "code": "32", "iso": "BE"},
    {"country": "Belize", "nameNl": "Belize", "code": "501", "iso": "BZ"},
    {"country": "Benin", "nameNl": "Benin", "code": "229", "iso": "BJ"},
    {"country": "Bermuda", "nameNl": "Bermuda", "code": "1-441", "iso": "BM"},
    {"country": "Bhutan", "nameNl": "Bhutan", "code": "975", "iso": "BT"},
    {"country": "Bolivia", "nameNl": "Bolivia", "code": "591", "iso": "BO"},
    {"country": "Bonaire, Sint Eustatius and Saba", "nameNl": "Bonaire, Sint Eustatius en Saba", "code": "599", "iso": "BQ"},
    {"country": "Bosnia and Herzegovina", "nameNl": "Bosnië en Herzegovina", "code": "387", "iso": "BA"},
    {"country": "Botswana", "nameNl": "Botswana", "code": "267", "iso": "BW"},
    {"country": "Bouvet Island", "nameNl": "Bouveteiland", "code": "47", "iso": "BV"},
    {"country": "Brazil", "nameNl": "Brazilië", "code": "55", "iso": "BR"},
    {"country": "British Indian Ocean Territory", "nameNl": "Brits Indische Oceaanterritorium", "code": "246", "iso": "IO"},
    {"country": "British Virgin Islands", "nameNl": "Britse Maagdeneilanden", "code": "1-284", "iso": "VG"},
    {"country": "Brunei", "nameNl": "Brunei", "code": "673", "iso": "BN"},
    {"country": "Bulgaria", "nameNl": "Bulgarije", "code": "359", "iso": "BG"},
    {"country": "Burkina Faso", "nameNl": "Burkina Faso", "code": "226", "iso": "BF"},
    {"country": "Burundi", "nameNl": "Burundi", "code": "257", "iso": "BI"},
    {"country": "Cambodia", "nameNl": "Cambodja", "code": "855", "iso": "KH"},
    {"country": "Cameroon", "nameNl": "Kameroen", "code": "237", "iso": "CM"},
    {"country": "Canada", "nameNl": "Canada", "code": "1", "iso": "CA"},
    {"country": "Cape Verde", "nameNl": "Kaapverdië", "code": "238", "iso": "CV"},
    {"country": "Cayman Islands", "nameNl": "Kaaimaneilanden", "code": "1-345", "iso": "KY"},
    {"country": "Central African Republic", "nameNl": "Centraal-Afrikaanse Republiek", "code": "236", "iso": "CF"},
    {"country": "Chad", "nameNl": "Tsjaad", "code": "235", "iso": "TD"},
    {"country": "Chile", "nameNl": "Chili", "code": "56", "iso": "CL"},
    {"country": "China", "nameNl": "China", "code": "86", "iso": "CN"},
    {"country": "Christmas Island", "nameNl": "Christmaseiland", "code": "61", "iso": "CX"},
    {"country": "Cocos Islands", "nameNl": "Cocoseilanden", "code": "61", "iso": "CC"},
    {"country": "Colombia", "nameNl": "Colombia", "code": "57", "iso": "CO"},
    {"country": "Comoros", "nameNl": "Comoren", "code": "269", "iso": "KM"},
    {"country": "Cook Islands", "nameNl": "Cookeilanden", "code": "682", "iso": "CK"},
    {"country": "Costa Rica", "nameNl": "Costa Rica", "code": "506", "iso": "CR"},
    {"country": "Croatia", "nameNl": "Kroatië", "code": "385", "iso": "HR"},
    {"country": "Cuba", "nameNl": "Cuba", "code": "53", "iso": "CU"},
    {"country": "Curacao", "nameNl": "Curaçao", "code": "599", "iso": "CW"},
    {"country": "Cyprus", "nameNl": "Cyprus", "code": "357", "iso": "CY"},
    {"country": "Czech Republic", "nameNl": "Tsjechië", "code": "420", "iso": "CZ"},
    {"country": "Democratic Republic of the Congo", "nameNl": "Congo-Kinshasa", "code": "243", "iso": "CD"},
    {"country": "Denmark", "nameNl": "Denemarken", "code": "45", "iso": "DK"},
    {"country": "Djibouti", "nameNl": "Djibouti", "code": "253", "iso": "DJ"},
    {"country": "Dominica", "nameNl": "Dominica", "code": "1-767", "iso": "DM"},
    {"country": "Dominican Republic", "nameNl": "Dominicaanse Republiek", "code": "1-809, 1-829, 1-849", "iso": "DO"},
    {"country": "East Timor", "nameNl": "Oost-Timor", "code": "670", "iso": "TL"},
    {"country": "Ecuador", "nameNl": "Ecuador", "code": "593", "iso": "EC"},
    {"country": "Egypt", "nameNl": "Egypte", "code": "20", "iso": "EG"},
    {"country": "El Salvador", "nameNl": "El Salvador", "code": "503", "iso": "SV"},
    {"country": "Equatorial Guinea", "nameNl": "Equatoriaal-Guinea", "code": "240", "iso": "GQ"},
    {"country": "Eritrea", "nameNl": "Eritrea", "code": "291", "iso": "ER"},
    {"country": "Estonia", "nameNl": "Estland", "code": "372", "iso": "EE"},
    {"country": "Ethiopia", "nameNl": "Ethiopië", "code": "251", "iso": "ET"},
    {"country": "Falkland Islands", "nameNl": "Falklandeilanden", "code": "500", "iso": "FK"},
    {"country": "Faroe Islands", "nameNl": "Faeröer", "code": "298", "iso": "FO"},
    {"country": "Fiji", "nameNl": "Fiji", "code": "679", "iso": "FJ"},
    {"country": "Finland", "nameNl": "Finland", "code": "358", "iso": "FI"},
    {"country": "France", "nameNl": "Frankrijk", "code": "33", "iso": "FR"},
    {"country": "French Guiana", "nameNl": "Frans-Guyana", "code": "594", "iso": "GF"},
    {"country": "French Polynesia", "nameNl": "Frans-Polynesië", "code": "689", "iso": "PF"},
    {"country": "French Southern Territories", "nameNl": "Franse Zuidelijke en Antarctische Gebieden", "code": "262", "iso": "TF"},
    {"country": "Gabon", "nameNl": "Gabon", "code": "241", "iso": "GA"},
    {"country": "Gambia", "nameNl": "Gambia", "code": "220", "iso": "GM"},
    {"country": "Georgia", "nameNl": "Georgië", "code": "995", "iso": "GE"},
    {"country": "Germany", "nameNl": "Duitsland", "code": "49", "iso": "DE"},
    {"country": "Ghana", "nameNl": "Ghana", "code": "233", "iso": "GH"},
    {"country": "Gibraltar", "nameNl": "Gibraltar", "code": "350", "iso": "GI"},
    {"country": "Greece", "nameNl": "Griekenland", "code": "30", "iso": "EL"},
    {"country": "Greenland", "nameNl": "Groenland", "code": "299", "iso": "GL"},
    {"country": "Grenada", "nameNl": "Grenada", "code": "1-473", "iso": "GD"},
    {"country": "Guadeloupe", "nameNl": "Guadeloupe", "code": "590", "iso": "GP"},
    {"country": "Guam", "nameNl": "Guam", "code": "1-671", "iso": "GU"},
    {"country": "Guatemala", "nameNl": "Guatemala", "code": "502", "iso": "GT"},
    {"country": "Guernsey", "nameNl": "Guernsey", "code": "44-1481", "iso": "GG"},
    {"country": "Guinea", "nameNl": "Guinee", "code": "224", "iso": "GN"},
    {"country": "Guinea-Bissau", "nameNl": "Guinee-Bissau", "code": "245", "iso": "GW"},
    {"country": "Guyana", "nameNl": "Guyana", "code": "592", "iso": "GY"},
    {"country": "Haiti", "nameNl": "Haïti", "code": "509", "iso": "HT"},
    {"country": "Heard Island and McDonald Islands", "nameNl": "Heard en McDonaldeilanden", "code": "672", "iso": "HM"},
    {"country": "Honduras", "nameNl": "Honduras", "code": "504", "iso": "HN"},
    {"country": "Hong Kong", "nameNl": "Hongkong SAR van China", "code": "852", "iso": "HK"},
    {"country": "Hungary", "nameNl": "Hongarije", "code": "36", "iso": "HU"},
    {"country": "Iceland", "nameNl": "IJsland", "code": "354", "iso": "IS"},
    {"country": "India", "nameNl": "India", "code": "91", "iso": "IN"},
    {"country": "Indonesia", "nameNl": "Indonesië", "code": "62", "iso": "ID"},
    {"country": "Iran", "nameNl": "Iran", "code": "98", "iso": "IR"},
    {"country": "Iraq", "nameNl": "Irak", "code": "964", "iso": "IQ"},
    {"country": "Ireland", "nameNl": "Ierland", "code": "353", "iso": "IE"},
    {"country": "Isle of Man", "nameNl": "Isle of Man", "code": "44-1624", "iso": "IM"},
    {"country": "Israel", "nameNl": "Israël", "code": "972", "iso": "IL"},
    {"country": "Italy", "nameNl": "Italië", "code": "39", "iso": "IT"},
    {"country": "Ivory Coast", "nameNl": "Ivoorkust", "code": "225", "iso": "CI"},
    {"country": "Jamaica", "nameNl": "Jamaica", "code": "1-876", "iso": "JM"},
    {"country": "Japan", "nameNl": "Japan", "code": "81", "iso": "JP"},
    {"country": "Jersey", "nameNl": "Jersey", "code": "44-1534", "iso": "JE"},
    {"country": "Jordan", "nameNl": "Jordanië", "code": "962", "iso": "JO"},
    {"country": "Kazakhstan", "nameNl": "Kazachstan", "code": "7", "iso": "KZ"},
    {"country": "Kenya", "nameNl": "Kenia", "code": "254", "iso": "KE"},
    {"country": "Kiribati", "nameNl": "Kiribati", "code": "686", "iso": "KI"},
    {"country": "Kuwait", "nameNl": "Koeweit", "code": "965", "iso": "KW"},
    {"country": "Kyrgyzstan", "nameNl": "Kirgizië", "code": "996", "iso": "KG"},
    {"country": "Laos", "nameNl": "Laos", "code": "856", "iso": "LA"},
    {"country": "Latvia", "nameNl": "Letland", "code": "371", "iso": "LV"},
    {"country": "Lebanon", "nameNl": "Libanon", "code": "961", "iso": "LB"},
    {"country": "Lesotho", "nameNl": "Lesotho", "code": "266", "iso": "LS"},
    {"country": "Liberia", "nameNl": "Liberia", "code": "231", "iso": "LR"},
    {"country": "Libya", "nameNl": "Libië", "code": "218", "iso": "LY"},
    {"country": "Liechtenstein", "nameNl": "Liechtenstein", "code": "423", "iso": "LI"},
    {"country": "Lithuania", "nameNl": "Litouwen", "code": "370", "iso": "LT"},
    {"country": "Luxembourg", "nameNl": "Luxemburg", "code": "352", "iso": "LU"},
    {"country": "Macao", "nameNl": "Macau SAR van China", "code": "853", "iso": "MO"},
    {"country": "Macedonia", "nameNl": "Noord-Macedonië", "code": "389", "iso": "MK"},
    {"country": "Madagascar", "nameNl": "Madagaskar", "code": "261", "iso": "MG"},
    {"country": "Malawi", "nameNl": "Malawi", "code": "265", "iso": "MW"},
    {"country": "Malaysia", "nameNl": "Maleisië", "code": "60", "iso": "MY"},
    {"country": "Maldives", "nameNl": "Maldiven", "code": "960", "iso": "MV"},
    {"country": "Mali", "nameNl": "Mali", "code": "223", "iso": "ML"},
    {"country": "Malta", "nameNl": "Malta", "code": "356", "iso": "MT"},
    {"country": "Marshall Islands", "nameNl": "Marshalleilanden", "code": "692", "iso": "MH"},
    {"country": "Martinique", "nameNl": "Martinique", "code": "596", "iso": "MQ"},
    {"country": "Mauritania", "nameNl": "Mauritanië", "code": "222", "iso": "MR"},
    {"country": "Mauritius", "nameNl": "Mauritius", "code": "230", "iso": "MU"},
    {"country": "Mayotte", "nameNl": "Mayotte", "code": "262", "iso": "YT"},
    {"country": "Mexico", "nameNl": "Mexico", "code": "52", "iso": "MX"},
    {"country": "Micronesia", "nameNl": "Micronesia", "code": "691", "iso": "FM"},
    {"country": "Moldova", "nameNl": "Moldavië", "code": "373", "iso": "MD"},
    {"country": "Monaco", "nameNl": "Monaco", "code": "377", "iso": "MC"},
    {"country": "Mongolia", "nameNl": "Mongolië", "code": "976", "iso": "MN"},
    {"country": "Montenegro", "nameNl": "Montenegro", "code": "382", "iso": "ME"},
    {"country": "Montserrat", "nameNl": "Montserrat", "code": "1-664", "iso": "MS"},
    {"country": "Morocco", "nameNl": "Marokko", "code": "212", "iso": "MA"},
    {"country": "Mozambique", "nameNl": "Mozambique", "code": "258", "iso": "MZ"},
    {"country": "Myanmar", "nameNl": "Myanmar (Birma)", "code": "95", "iso": "MM"},
    {"country": "Namibia", "nameNl": "Namibië", "code": "264", "iso": "NA"},
    {"country": "Nauru", "nameNl": "Nauru", "code": "674", "iso": "NR"},
    {"country": "Nepal", "nameNl": "Nepal", "code": "977", "iso": "NP"},
    {"country": "Netherlands", "nameNl": "Nederland", "code": "31", "iso": "NL"},
    {"country": "New Caledonia", "nameNl": "Nieuw-Caledonië", "code": "687", "iso": "NC"},
    {"country": "New Zealand", "nameNl": "Nieuw-Zeeland", "code": "64", "iso": "NZ"},
    {"country": "Nicaragua", "nameNl": "Nicaragua", "code": "505", "iso": "NI"},
    {"country": "Niger", "nameNl": "Niger", "code": "227", "iso": "NE"},
    {"country": "Nigeria", "nameNl": "Nigeria", "code": "234", "iso": "NG"},
    {"country": "Niue", "nameNl": "Niue", "code": "683", "iso": "NU"},
    {"country": "Norfolk Island", "nameNl": "Norfolk", "code": "672", "iso": "NF"},
    {"country": "North Korea", "nameNl": "Noord-Korea", "code": "850", "iso": "KP"},
    {"country": "Northern Ireland", "nameNl": "Noord-Ierland", "code": "44", "iso": "XI"},
    {"country": "Northern Mariana Islands", "nameNl": "Noordelijke Marianen", "code": "1-670", "iso": "MP"},
    {"country": "Norway", "nameNl": "Noorwegen", "code": "47", "iso": "NO"},
    {"country": "Oman", "nameNl": "Oman", "code": "968", "iso": "OM"},
    {"country": "Pakistan", "nameNl": "Pakistan", "code": "92", "iso": "PK"},
    {"country": "Palau", "nameNl": "Palau", "code": "680", "iso": "PW"},
    {"country": "Palestine", "nameNl": "Palestijnse gebieden", "code": "970", "iso": "PS"},
    {"country": "Panama", "nameNl": "Panama", "code": "507", "iso": "PA"},
    {"country": "Papua New Guinea", "nameNl": "Papoea-Nieuw-Guinea", "code": "675", "iso": "PG"},
    {"country": "Paraguay", "nameNl": "Paraguay", "code": "595", "iso": "PY"},
    {"country": "Peru", "nameNl": "Peru", "code": "51", "iso": "PE"},
    {"country": "Philippines", "nameNl": "Filipijnen", "code": "63", "iso": "PH"},
    {"country": "Pitcairn", "nameNl": "Pitcairneilanden", "code": "64", "iso": "PN"},
    {"country": "Poland", "nameNl": "Polen", "code": "48", "iso": "PL"},
    {"country": "Portugal", "nameNl": "Portugal", "code": "351", "iso": "PT"},
    {"country": "Puerto Rico", "nameNl": "Puerto Rico", "code": "1-787, 1-939", "iso": "PR"},
    {"country": "Qatar", "nameNl": "Qatar", "code": "974", "iso": "QA"},
    {"country": "Republic of the Congo", "nameNl": "Congo-Brazzaville", "code": "242", "iso": "CG"},
    {"country": "Reunion", "nameNl": "Réunion", "code": "262", "iso": "RE"},
    {"country": "Romania", "nameNl": "Roemenië", "code": "40", "iso": "RO"},
    {"country": "Russia", "nameNl": "Rusland", "code": "7", "iso": "RU"},
    {"country": "Rwanda", "nameNl": "Rwanda", "code": "250", "iso": "RW"},
    {"country": "Saint Barthélemy", "nameNl": "Saint-Barthélemy", "code": "590", "iso": "BL"},
    {"country": "Saint Helena", "nameNl": "Sint-Helena", "code": "290", "iso": "SH"},
    {"country": "Saint Kitts and Nevis", "nameNl": "Saint Kitts en Nevis", "code": "1-869", "iso": "KN"},
    {"country": "Saint Lucia", "nameNl": "Saint Lucia", "code": "1-758", "iso": "LC"},
    {"country": "Saint Martin", "nameNl": "Saint-Martin", "code": "590", "iso": "MF"},
    {"country": "Saint Pierre and Miquelon", "nameNl": "Saint-Pierre en Miquelon", "code": "508", "iso": "PM"},
    {"country": "Saint Vincent and the Grenadines", "nameNl": "Saint Vincent en de Grenadines", "code": "1-784", "iso": "VC"},
    {"country": "Samoa", "nameNl": "Samoa", "code": "685", "iso": "WS"},
    {"country": "San Marino", "nameNl": "San Marino", "code": "378", "iso": "SM"},
    {"country": "Sao Tome and Principe", "nameNl": "Sao Tomé en Principe", "code": "239", "iso": "ST"},
    {"country": "Saudi Arabia", "nameNl": "Saoedi-Arabië", "code": "966", "iso": "SA"},
    {"country": "Senegal", "nameNl": "Senegal", "code": "221", "iso": "SN"},
    {"country": "Serbia", "nameNl": "Servië", "code": "381", "iso": "RS"},
    {"country": "Seychelles", "nameNl": "Seychellen", "code": "248", "iso": "SC"},
    {"country": "Sierra Leone", "nameNl": "Sierra Leone", "code": "232", "iso": "SL"},
    {"country": "Singapore", "nameNl": "Singapore", "code": "65", "iso": "SG"},
    {"country": "Sint Maarten", "nameNl": "Sint Maarten", "code": "1-721", "iso": "SX"},
    {"country": "Slovakia", "nameNl": "Slowakije", "code": "421", "iso": "SK"},
    {"country": "Slovenia", "nameNl": "Slovenië", "code": "386", "iso": "SI"},
    {"country": "Solomon Islands", "nameNl": "Salomonseilanden", "code": "677", "iso": "SB"},
    {"country": "Somalia", "nameNl": "Somalië", "code": "252", "iso": "SO"},
    {"country": "South Africa", "nameNl": "Zuid-Afrika", "code": "27", "iso": "ZA"},
    {"country": "South Georgia and the South Sandwich Islands", "nameNl": "Zuid-Georgia en de Zuidelijke Sandwicheilanden", "code": "500", "iso": "GS"},
    {"country": "South Korea", "nameNl": "Zuid-Korea", "code": "82", "iso": "KR"},
    {"country": "South Sudan", "nameNl": "Zuid-Soedan", "code": "211", "iso": "SS"},
    {"country": "Spain", "nameNl": "Spanje", "code": "34", "iso": "ES"},
    {"country": "Sri Lanka", "nameNl": "Sri Lanka", "code": "94", "iso": "LK"},
    {"country": "Sudan", "nameNl": "Soedan", "code": "249", "iso": "SD"},
    {"country": "Suriname", "nameNl": "Suriname", "code": "597", "iso": "SR"},
    {"country": "Svalbard and Jan Mayen", "nameNl": "Spitsbergen en Jan Mayen", "code": "47", "iso": "SJ"},
    {"country": "Swaziland", "nameNl": "Eswatini", "code": "268", "iso": "SZ"},
    {"country": "Sweden", "nameNl": "Zweden", "code": "46", "iso": "SE"},
    {"country": "Switzerland", "nameNl": "Zwitserland", "code": "41", "iso": "CH"},
    {"country": "Syria", "nameNl": "Syrië", "code": "963", "iso": "SY"},
    {"country": "Taiwan", "nameNl": "Taiwan", "code": "886", "iso": "TW"},
    {"country": "Tajikistan", "nameNl": "Tadzjikistan", "code": "992", "iso": "TJ"},
    {"country": "Tanzania", "nameNl": "Tanzania", "code": "255", "iso": "TZ"},
    {"country": "Thailand", "nameNl": "Thailand", "code": "66", "iso": "TH"},
    {"country": "Togo", "nameNl": "Togo", "code": "228", "iso": "TG"},
    {"country": "Tokelau", "nameNl": "Tokelau", "code": "690", "iso": "TK"},
    {"country": "Tonga", "nameNl": "Tonga", "code": "676", "iso": "TO"},
    {"country": "Trinidad and Tobago", "nameNl": "Trinidad en Tobago", "code": "1-868", "iso": "TT"},
    {"country": "Tunisia", "nameNl": "Tunesië", "code": "216", "iso": "TN"},
    {"country": "Turkey", "nameNl": "Turkije", "code": "90", "iso": "TR"},
    {"country": "Turkmenistan", "nameNl": "Turkmenistan", "code": "993", "iso": "TM"},
    {"country": "Turks and Caicos Islands", "nameNl": "Turks- en Caicoseilanden", "code": "1-649", "iso": "TC"},
    {"country": "Tuvalu", "nameNl": "Tuvalu", "code": "688", "iso": "TV"},
    {"country": "U.S. Virgin Islands", "nameNl": "Amerikaanse Maagdeneilanden", "code": "1-340", "iso": "VI"},
    {"country": "Uganda", "nameNl": "Oeganda", "code": "256", "iso": "UG"},
    {"country": "Ukraine", "nameNl": "Oekraïne", "code": "380", "iso": "UA"},
    {"country": "United Arab Emirates", "nameNl": "Verenigde Arabische Emiraten", "code": "971", "iso": "AE"},
    {"country": "United Kingdom", "nameNl": "Verenigd Koninkrijk", "code": "44", "iso": "GB"},
    {"country": "United States", "nameNl": "Verenigde Staten", "code": "1", "iso": "US"},
    {"country": "United States Minor Outlying Islands", "nameNl": "Kleine afgelegen eilanden van de Verenigde Staten", "code": "1", "iso": "UM"},
    {"country": "Uruguay", "nameNl": "Uruguay", "code": "598", "iso": "UY"},
    {"country": "Uzbekistan", "nameNl": "Oezbekistan", "code": "998", "iso": "UZ"},
    {"country": "Vanuatu", "nameNl": "Vanuatu", "code": "678", "iso": "VU"},
    {"country": "Vatican", "nameNl": "Vaticaanstad", "code": "379", "iso": "VA"},
    {"country": "Venezuela", "nameNl": "Venezuela", "code": "58", "iso": "VE"},
    {"country": "Vietnam", "nameNl": "Vietnam", "code": "84", "iso": "VN"},
    {"country": "Wallis and Futuna", "nameNl": "Wallis en Futuna", "code": "681", "iso": "WF"},
    {"country": "Western Sahara", "nameNl": "Westelijke Sahara", "code": "212", "iso": "EH"},
    {"country": "Yemen", "nameNl": "Jemen", "code": "967", "iso": "YE"},
    {"country": "Zambia", "nameNl": "Zambia", "code": "260", "iso": "ZM"},
    {"country": "Zimbabwe", "nameNl": "Zimbabwe", "code": "263", "iso": "ZW"}
    // {"country":"Kosovo","code":"383","iso":"XK"},
];

export const COUNTRIES_NL_SORTED: CountryInfo[] = [...COUNTRIES].sort(
    (a, b) => a.nameNl.localeCompare(b.nameNl, 'nl'),
);

export function isCountry(value: string): value is Country {
    return COUNTRIES.some((country) => country.iso === value);
}

const PREFERRED_COUNTRY_BY_DIAL_CODE: Record<string, Country> = {
    "44": "GB",
    "47": "NO",
    "262": "YT",
    "358": "FI",
    "590": "MF",
    "599": "CW",
};

export function countryByDialCode(code: string): CountryInfo | undefined {
    const preferred = PREFERRED_COUNTRY_BY_DIAL_CODE[code];
    return COUNTRIES.find((country) => country.iso === preferred)
        ?? COUNTRIES.find((country) => country.code === code);
}
